import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-commentaire-modification',
    templateUrl: './commentaire-modification.component.html',
    styleUrls: ['./commentaire-modification.component.scss'],
    standalone: false
})
export class CommentaireModificationComponent implements OnInit {
    /**
     * Formulaire
     */
    formGroup: FormGroup;

    /**
     * Getter commentaire
     */
    get commentaire() {
        return this.formGroup.get('commentaire');
    }

    constructor(public readonly modal: NgbActiveModal, private readonly fg: FormBuilder) {}

    /**
     * On init component
     */
    ngOnInit() {
        this.formGroup = this.fg.group({
            commentaire: [null, Validators.required]
        });
    }

    /**
     * Confirmer l'ajout du commentaire
     */
    onTerminer() {
        this.modal.close({ commentaire: this.commentaire.value });
    }

    /**
     * Annuler l'ajout du commentaire
     */
    onAnnuler() {
        this.modal.dismiss();
    }
}
